import React from 'react'
import { isMobile } from 'react-device-detect'
import { SideBar } from '../SideBar/SideBar'

const SideBarRight: React.FC = ({
    children
}) => (
    <SideBar position='right' top={isMobile ? '8px' : '5px'}>
        {children}
    </SideBar>
)

export default SideBarRight